import { t } from "i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import type { QuestionResult } from "models";

type SolutionElementProps = {
  questionResult: QuestionResult;
};

export const SolutionElement = ({ questionResult }: SolutionElementProps) => {
  if (!questionResult.solution_value || !questionResult.solution_unit || !questionResult.solution_type) return null;

  return (
    <Popup
      position="top right"
      trigger={
        <Label basic className="solution-element-label">
          <Icon className="clipboard list solid solution-element-icon" />
        </Label>
      }
      content={
        <div className="solution-element">
          <div className="solution-item">
            <span className="solution-unit">
              <strong>{t("v8_intervention", "Intervention")}</strong>
            </span>
            <span className="solution-element-value">{questionResult.solution_unit}</span>
          </div>
          <div className="solution-item">
            <span className="solution-unit">
              <strong>{t("value", "Value")}</strong>
            </span>
            <span className="solution-element-value">{questionResult.solution_value}</span>
          </div>
          <div className="solution-item">
            <span className="solution-unit">
              <strong>{t("type", "Type")}</strong>
            </span>
            <span className="solution-element-value">{questionResult.solution_type}</span>
          </div>
        </div>
      }
    />
  );
};
